import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    standalone: false,
    selector: 'input[alphabetsWithSymbols]'
})
export class AlphabetsWithSymbols {

    constructor(private _el: ElementRef) { }

    @HostListener("keydown", ["$event"]) public onKeydown(event: KeyboardEvent) {
        /* IES-5562: browser autofill fires a keydown without a key, there is nothing to filter. */
        if (!event.key) {
            return;
        }
        if (event.key !== event.key.replace(/[^A-Za-z \-_"\']*/g, '')) {
            event.preventDefault();
        }

    }
}